import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import { of, Subscription } from 'rxjs';
import { first, map, mergeMap } from 'rxjs/operators';
import { ActivityFilterParamsInterface } from '~/attendee/interfaces/activity-filter-params.interface';

import { PaginatedSearchService } from '~/attendee/service/paginated-search.service';
import { SubscriptionSearchService } from '~/attendee/service/subscription-search.service';
import { buildRangeQuery } from '~/cms/helpers/build-range-query.helper';
import { OfferSectionCms } from '~/cms/interfaces/homepage.cms.interface';
import { Activity } from '~/core/model/activity.model';

@Component({
  selector: 'app-cms-offer-section',
  templateUrl: './offer-section.component.html',
})
export class CmsOfferSectionComponent implements OnInit, OnDestroy {
  @Input() public section: OfferSectionCms;
  private readonly subscriptions = new Subscription();
  public activities: Activity[];

  constructor(
    private readonly subscriptionSearchService: SubscriptionSearchService,
    protected readonly translateService: TranslateService,
    protected readonly localizeRouterService: LocalizeRouterService,
    @Inject('ActivitySearchService')
    private readonly searchService: PaginatedSearchService<
      Activity,
      ActivityFilterParamsInterface
    >
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    const observable$ = of(undefined);

    this.subscriptions.add(
      observable$
        .pipe(
          map(() => {
            return this.subscriptionSearchService.getOfferPageActivitiesFilters(
              this.section.offer_page?.akeneo_group_id,
              buildRangeQuery(this.section.offer_page?.price_range)
            );
          }),
          mergeMap((filters) => {
            return this.searchService
              .search({
                ...filters,
                pagination: {
                  from: 0,
                  limit: this.section.number_to_display,
                },
                includeNextDates: true,
              })
              .pipe(
                first(),
                map((paginatedResponse) => paginatedResponse.items)
              );
          })
        )
        .subscribe((activities) => {
          this.activities = activities;
        })
    );
  }

  public get link(): {
    path: string;
    text: string;
  } {
    return {
      text: this.translateService.instant(
        'attendee.offer_collection.cta.see_more.label'
      ),
      path: this.localizeRouterService
        .translateRoute(`/c/${this.section?.offer_page?.slug}`)
        .toString(),
    };
  }
}
